<template>
  <div class="flex items-center gap-4 p-4 leading-tight">
    <div class="flex-none overflow-hidden">
      <div class="flex items-center justify-center flex-none w-12 h-12 overflow-hidden border rounded bg-gray-50">
        <img v-if="product.image" :src="product.image" :alt="product.name" class="object-cover h-full">
        <fa v-else :icon="['far', 'cube']" class="text-lg text-gray-300" />
      </div>
    </div>
    <div class="flex items-center justify-between flex-grow">
      <div>
        <div class="flex justify-between text-sm font-bold">
          {{ product.name }}
        </div>
        <div class="text-sm text-gray-500 line-clamp-2">
          {{ product.description }}
        </div>
        <div v-if="product.price" class="flex gap-1 text-sm text-gray-500">
          <currency :value="displayPrice" :currency-code="portal.currency" :subunits-value="true" />
          {{ portal.display_prices_excluding_tax ? `(excl. ${portal.tax_name})` : `(incl. ${portal.tax_name})` }}
        </div>
      </div>
    </div>
    <div class="flex-none">
      <div class="flex items-center gap-2">
        <button 
          class="grid w-6 h-6 font-semibold text-gray-600 bg-gray-200 rounded-full place-items-center hover:bg-gray-300" 
          @click="$emit('decrease', product)">
          -
        </button>
        <div class="text-center bg-white border rounded-md shadow-sm">
          <div class="py-0.5 text-xs font-medium text-gray-500 bg-gray-100 rounded-t-md">
            Qty
          </div>
          <input 
            readonly
            type="text" 
            class="w-10 h-8 text-center bg-transparent" 
            :value="quantity">
        </div>
        <button 
          class="grid w-6 h-6 font-semibold text-gray-600 bg-gray-200 rounded-full place-items-center hover:bg-gray-300" 
          @click="$emit('increase', product)">
          +
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'BookingProductItem',

  props: {
    address: {
      type: Object,
      required: true
    },

    product: {
      type: Object,
      required: true
    }
  },

  computed: {
    ...mapState(['portal']),
    ...mapState('booking', ['options']),

    displayPrice () {
      let price = this.product.price
      
      if (this.portal.display_prices_excluding_tax) {
        price = price / (1 + this.portal.tax_rate / 100)
      }

      if (this.portal.round_display_prices) {
        price = Math.round(price/100)*100
      }

      return price
    },
    
    quantity () {
      const productIndex = this.address.products.findIndex((product) => product.id === this.product.id)
      
      if (productIndex > -1) {
        return this.address.products[productIndex].quantity
      } else {
        return 0
      }
    }
  }
}
</script>